'use client';

import {PageSection} from '@/@types/site';
import {createContext, useContext, useState, ReactNode} from 'react';

interface NavigationContextType {
    sections: PageSection[];
    ticketRef: string;
    showSocialLinks: boolean;
    setNavigation: (sections: PageSection[], ticketRef?: string, showSocialLinks?: boolean) => void;
}


const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

interface NavigationProviderProps {
    children: ReactNode;
    initialNavigation?: {
        sections: PageSection[];
        ticketRef: string;
        showSocialLinks: boolean;
    };
}

/**
 * Default navigation for main SPA pages
 */
const defaultNavigation = {
    sections: [
    ] as PageSection[],
    ticketRef: 'atc-website-nav',
    showSocialLinks: true,
};

export function NavigationProvider({
                                       children,
                                       initialNavigation = defaultNavigation
                                   }: NavigationProviderProps) {
    const [navigation, setNavigationState] = useState(initialNavigation);

    const setNavigation = (sections: PageSection[], ticketRef = 'atc-website-nav', showSocialLinks = true) => {
        setNavigationState({sections, ticketRef, showSocialLinks});
    };

    return (
        <NavigationContext.Provider value={{...navigation, setNavigation}}>
            {children}
        </NavigationContext.Provider>
    );
}

export function useNavigation() {
    const context = useContext(NavigationContext);
    if (context === undefined) {
        throw new Error('useNavigation must be used within a NavigationProvider');
    }
    return context;
}
